export function initSignInFocus(): void {
    const passwordInput = $('input[name=password]');

    if (!passwordInput.is(':focus')) {
        $('input[name=username]').trigger('focus');
    }
}

export function initSignInTotp(): void {
    const submitTotp = (): boolean => {
        const code = String($('#totpCode2').val() ?? '');

        if (code) {
            $('#totpCode').val(code);
            $('#login').trigger('click');
        }

        return false;
    };

    window.submitTotp = submitTotp;

    $(document)
        .off('submit.naisTotp', '[data-nais-totp-form]')
        .on('submit.naisTotp', '[data-nais-totp-form]', (event) => {
            event.preventDefault();
            submitTotp();
        });

    $(document)
        .off('click.naisTotp', '[data-action="nais-submit-totp"]')
        .on('click.naisTotp', '[data-action="nais-submit-totp"]', (event) => {
            event.preventDefault();
            submitTotp();
        });
}
